<template>
  <div class="fullheight FeAsideTree">
    <el-aside class="fullheight" :width="width" style="border-right: 1px solid #eee" v-show="asideShow">
      <fe-sys-type-tree
        class="fe-sys-type-tree"
        :type-key="typeKey"
        highlight-current
        ref="feSysTypeTree"
        :support-filter="supportFilter"
        :default-expand-all="isExpand"
        :show-checkbox="showCheckbox"
        :default-expanded-keys="defaultExpandedKeys"
        expand-on-click-node="false"
        @node-click="handleNodeClick"
        @check="check"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span class="show-ellipsis" :title="node.label">{{ node.label }}</span>
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link" v-if="canAdd || canEdit || canDel">
              <img src="@/assets/img/iconMore.png" class="iconMore" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item icon="el-icon-plus" :command="{ node: node, data, action: 'add' }" v-if="node.level < 3 && canAdd">添加</el-dropdown-item>
              <el-dropdown-item icon="el-icon-edit" v-if="data.parentId != '0' && canEdit" :command="{ node: node, data, action: 'edit' }"
                >编辑</el-dropdown-item
              >
              <el-dropdown-item icon="el-icon-delete" v-if="data.parentId != '0' && canDel" :command="{ node: node, data, action: 'delete' }" divided
                >删除</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </span>
      </fe-sys-type-tree>
      <!-- <el-footer height="30px" class="el-aside-footer" v-if="hasFooter">
        <el-switch
          class="footer"
          v-model="showCheckbox"
          active-text="多选"
          inactive-text="单选"
        ></el-switch>
      </el-footer> -->
    </el-aside>

    <div
      class="navbar-collapse"
      :class="{ 'navbar-collapse-right': !asideShow }"
      v-if="hasNavbarCollapse"
      :style="navbarCollapseStyle"
      @click="asideShow = !asideShow"
    >
      <div class="navbar-collapse-bg">
        <i
          class="navbar-collapse-arrow"
          :class="{
            'el-icon-arrow-left': asideShow,
            'el-icon-arrow-right': !asideShow
          }"
        ></i>
      </div>
    </div>
    <!-- 添加分类 -->
    <eco-sidebar-dialog
      destroy-on-close
      width="28%"
      :title="sysType.id ? '编辑' : '添加'"
      :visible.sync="dialogVisible"
      append-to-body
      :before-close="handleClose"
    >
      <el-form :model="sysType" data-vv-scope="editSysTypeForm" style="padding: 20px">
        <eco-form-item label="父节点" v-if="!sysType.id">
          <eco-input v-model="parentSysType.name" autocomplete="off" validate="required" disabled></eco-input>
        </eco-form-item>
        <eco-form-item label="分类名称">
          <eco-input v-model="sysType.name" autocomplete="off" validate="required"></eco-input>
        </eco-form-item>
        <eco-form-item label="分类Key">
          <eco-input
            v-model="sysType.typeKey"
            v-pinyin="sysType.name"
            :disabled="sysType.id ? true : false"
            autocomplete="off"
            :validate="{ required: true, alpha_num: true }"
            placeholder="请输入key"
          />
        </eco-form-item>
        <eco-form-item label="排序">
          <el-input v-model.number="sysType.sn" style="width: 192px" @input="sysType.sn=sysType.sn.replace(/[^\d]/g,'')"></el-input>
        </eco-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <fe-submit-button :url="saveSysTypeUrl" :model="sysType" scope-name="editSysTypeForm" @after-save-data="afterSaveData">{{
          $t('eip.common.save')
        }}</fe-submit-button>
      </div>
    </eco-sidebar-dialog>
  </div>
</template>

<script>
import styles from '@/assets/css/element-variables.scss'
import sys from '@/api/portal.js'
const feSysTypeTree = () => import('@/views/system/components/FeSysTypeTree.vue')
export default {
  name: 'fe-aside-tree',
  components: {
    feSysTypeTree
  },
  props: {
    width: {
      type: String,
      default: styles.aside_width
    },
    catId: {
      type: String,
      default: ''
    },
    from: {
      type: String,
      default: ''
    },
    typeKey: {
      type: String,
      default: ''
    },
    searchUrl: {
      type: String,
      default: ''
    },
    supportFilter: {
      type: Boolean,
      default: true
    },
    hasFooter: {
      type: Boolean,
      default: true
    },
    hasNavbarCollapse: {
      type: Boolean,
      default: true
    },
    canAdd: {
      type: Boolean,
      default: true
    },
    canEdit: {
      type: Boolean,
      default: true
    },
    canDel: {
      type: Boolean,
      default: true
    },
    defaultExpandedKeys: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    navbarCollapseStyle: function () {
      if (this.asideShow) {
        return { left: parseInt(this.width) + 'px' }
      }
      return { left: '0px' }
    },
    saveSysTypeUrl: function () {
      return `${window.context.portal}/sys/sysType/v1/save?parentId=${this.parentSysType.id}&isRoot=${this.parentSysType.parentId == 0 ? 1 : 0}&isPriNode=0`
    }
  },
  data() {
    return {
      asideShow: true,
      isExpand: false,
      showCheckbox: false,
      dialogVisible: false,
      sysType: {
        children: [],
        isLeaf: 'N',
        struType: 1,
        typeKey: '',
        sn: null,
        name: ''
      },
      parentSysType: {
        name: ''
      }
    }
  },
  watch: {
    catId: function (newVal, oldVal) {
      if (newVal && newVal != oldVal) {
        setTimeout(() => {
          this.$refs.feSysTypeTree.loadData()
        })
      }
    },
    'sysType.name': function (newVal) {
      if (newVal == '' && !this.sysType.id) {
        this.sysType.typeKey = ''
      }
    }
  },
  mounted() {
    // this.$validator = this.$root.$validator;
  },
  methods: {
    handleNodeClick(node) {
      this.$emit('node-click', node)
    },
    check(data, checkedObj) {
      this.$emit('check', data, checkedObj)
    },
    handleCommand(command) {
      let node = command.node
      let data = command.data
      let action = command.action
      switch (action) {
        case 'add':
          this.showDialog(data, action)
          break
        case 'edit':
          this.showDialog(data, action)
          break
        case 'delete':
          this.delSysTypecheck(node, data)
          break
        case 'moveto':
          this.$message.error('暂未提供该功能')
          break
        default:
          break
      }
    },
    showDialog(data, action) {
      this.dialogVisible = true

      if (data && action == 'add') {
        this.sysType.id = ''
        this.sysType.sn = null
        this.sysType.name = ''
        this.sysType.typeKey = ''
        this.parentSysType = data
        this.sysType.parentId = data.id
        this.sysType.typeGroupKey = data.parentId == 0 ? data.typeKey : data.typeGroupKey
      }
      if (data && action == 'edit') {
        this.sysType = { ...this.sysType, ...data }
      }
    },
    delSysTypecheck(node, data) {
      if (data.children && data.children.length > 0) {
        this.$message.info('该分类下已有子分类，无法删除')
      } else {
        const param = {
          pageBean: { page: 1, pageSize: 50, total: 0 },
          querys: [
            {
              property: 'type',
              value: data.typeKey,
              group: 'type',
              operation: 'EQUAL',
              relation: 'AND'
            }
          ]
        }

        this.$http.post(this.searchUrl, param).then(
          (resp) => {
            let response = resp.data
            if (response.rows && response.rows.length > 0) {
              this.$message.info('该分类下已有数据，无法删除该分类。')
            } else {
              this.delSysType(node, data)
            }
          },
          (error) => {
            reject(error)
          }
        )
      }
    },

    delSysType(node, data) {
      this.$confirm(`是否确定删除 [${data.name}] ?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          sys
            .delSysType(data.id)
            .then(
              (data) => {
                if (data.state) {
                  this.$message.success(data.message || '删除成功')
                  this.$refs.feSysTypeTree.loadData()
                  this.$emit('delete', data)
                } else {
                  this.$message.error(data.message || '删除成功')
                }
              },
              (error) => {
                this.$message.error(error || '删除失败')
              }
            )
            .catch(() => {
              this.dialogVisible = false
            })
        })
        .catch(() => {})
    },
    handleClose() {
      this.dialogVisible = false
    },
    afterSaveData() {
      this.$refs.feSysTypeTree.loadData()
      if (this.sysType.id) {
        this.dialogVisible = false
        return
      }
      this.sysType.name = ''
      this.sysType.typeKey = ''
      this.sysType.sn = null
      this.$confirm('是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success'
      })
        .then(() => {})
        .catch(() => {
          this.dialogVisible = false
        })
    }
  }
}
</script>

<style lang="scss">
.FeAsideTree {
  .fe-sys-type-tree {
    width: 100%;
    height: 100%;
  }

  .el-dropdown {
    display: none;
  }
  .el-header {
    border-bottom: 1px solid #ccc;
    button {
      float: right;
      margin-left: 5px;
    }
  }

  .el-tree-node__content:hover .el-dropdown {
    display: inline-block;
  }

  .navbar-collapse {
    position: relative;
    top: -60%;
    cursor: pointer;
    width: 20px;
  }

  .navbar-collapse.navbar-collapse-right {
    top: 40%;
  }

  .navbar-collapse:hover {
    transform: scale(1) translateY(2px);
  }

  .navbar-collapse:hover .navbar-collapse-arrow {
    color: #333333;
  }

  .navbar-collapse-arrow {
    position: relative;
    margin-top: 15px;
    right: 15px;
    font-size: 18px;
    color: #a8a8a8;
  }

  .navbar-collapse-bg {
    -webkit-transition: all 0.12s ease;
    height: 50px;
    border-bottom: 8px solid transparent;
    border-right: none;
    border-left: 12px solid #ebebeb;
    border-top: 8px solid transparent;
    opacity: 0.9;
  }
  .el-aside-footer {
    position: absolute;
    bottom: 7px;
  }

  .custom-tree-node {
    width: calc(100% - 40px);
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }

  .custom-tree-node i {
    visibility: hidden;
    font-weight: bold;
  }

  .custom-tree-node:hover i {
    visibility: visible;
  }
}
</style>
